import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * Workflow configurator (stage editor) UI copy.
 * Keys must exist in `src/intl/locale/messages.*.json`.
 */
export const WorkflowConfigurationTranslationKeys = {
  ENABLE_APPROVAL: translationKey('workflow_creator_enable_approval'),
  APPROVAL_ENABLED: translationKey('workflow_creator_approval_enabled'),
  REQUIRED_APPROVALS_LABEL: translationKey(
    'workflow_creator_required_approvals_label'
  ),
  REQUIRED_APPROVALS_OF_TOTAL: translationKey(
    'workflow_creator_required_approvals_of_total'
  ),
  STAGE_NAME_REQUIRED: translationKey('workflow_creator_stage_name_required'),
} as const satisfies Record<string, TranslationKey>;
